import axios from 'axios';
import { IframelyMedia } from '@prismamedia/one-components';

const iframelyEndpoint = `${config.IFRAMELY_API_BASEPATH}/iframely`;

export const getIframely = async (url: string): Promise<IframelyMedia> => {
  const result = await axios.get(
    `${iframelyEndpoint}?uri=${encodeURIComponent(url)}`,
  );
  return result.data;
};
